module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [(Number(_vm.userInfo.crmCustomerType) === 1) ? _c('div', [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("实名认证")]), _vm._v(" "), _c('div', {
    staticClass: "personal-center-form__main"
  }, [_c('el-row', {
    staticClass: "personal-center-form__form",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "realAuthForm",
    attrs: {
      "label-width": '50%',
      "model": _vm.realAuthFormModel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行卡号",
      "prop": "cardno"
    }
  }, [_c('el-select', {
    style: ({
      width: '100%'
    }),
    attrs: {
      "placeholder": "请选择银行卡号"
    },
    model: {
      value: (_vm.realAuthFormModel.cardno),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "cardno", $$v)
      },
      expression: "realAuthFormModel.cardno"
    }
  }, _vm._l((_vm.bankList), function(item) {
    return _c('el-option', {
      key: item.bankAccountName,
      attrs: {
        "label": item.bankAccountName,
        "value": item.bankAccountName
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectCardNO(item.bankAccountName)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行预留手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号",
      "maxlength": 11,
      "disabled": true
    },
    model: {
      value: (_vm.realAuthFormModel.mobile),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "mobile", $$v)
      },
      expression: "realAuthFormModel.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.realAuthFormModel.name),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "name", $$v)
      },
      expression: "realAuthFormModel.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号码",
      "prop": "idno"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入身份证号码",
      "disabled": _vm.isEditable,
      "maxlength": _vm.IDMaxLength
    },
    model: {
      value: (_vm.realAuthFormModel.idno),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "idno", $$v)
      },
      expression: "realAuthFormModel.idno"
    }
  })], 1), _vm._v(" "), (!_vm.isAuth) ? _c('div', [_c('el-form-item', {
    staticClass: "SMS-cont",
    attrs: {
      "label": "短信验证码",
      "prop": "SMSCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入短信验证码",
      "disabled": !_vm.SMSCodeBtn.btnState,
      "maxlength": 6
    },
    model: {
      value: (_vm.realAuthFormModel.SMSCode),
      callback: function($$v) {
        _vm.$set(_vm.realAuthFormModel, "SMSCode", $$v)
      },
      expression: "realAuthFormModel.SMSCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-button-sms-code",
    attrs: {
      "type": "primary",
      "size": "mini",
      "disabled": _vm.stateCode === 3 ? true : _vm.SMSCodeBtn.btnState
    },
    on: {
      "click": _vm.getSMSCode
    }
  }, [_vm._v(_vm._s(_vm.SMSCodeBtn.text) + "\n                  ")])], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips_info el-icon-information"
  }, [_vm._v("如有信息出错，请联系管理员修改")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.stateCode !== 3) ? _c('el-button', {
    staticClass: "personal-center-form__submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交\n          ")]) : _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.stateCode === 3
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("已实名认证\n          ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (Number(_vm.userInfo.crmCustomerType) === 2) ? _c('div', [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("企业认证")]), _vm._v(" "), _c('div', {
    staticClass: "personal-center-form__main"
  }, [_c('el-row', {
    staticClass: "personal-center-form__form",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "realAuthForm",
    attrs: {
      "label-width": '50%',
      "model": _vm.enterpriseInfoFormModel,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "required": true,
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入客户名称",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.customerName),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "customerName", $$v)
      },
      expression: "enterpriseInfoFormModel.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号",
      "required": true,
      "prop": "enterpriseNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入营业执照号",
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册人类型",
      "required": true,
      "prop": "userType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.userType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "userType", $$v)
      },
      expression: "enterpriseInfoFormModel.userType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("法人注册")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("代理人注册")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人' : '代理人',
      "required": true,
      "prop": "enterpriseLegalUser"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人' : '请输入代理人',
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalUser),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalUser", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalUser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号',
      "required": true,
      "prop": "enterpriseLegalIdNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号',
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalIdNo),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalIdNo", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalIdNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '法人联系电话' : '代理人联系电话',
      "required": true,
      "prop": "enterpriseLegalUserPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": Number(_vm.enterpriseInfoFormModel.userType) === 2 ? '请输入法人联系电话' : '请输入法人联系电话',
      "disabled": _vm.isEditable,
      "maxlength": 11
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseLegalUserPhone),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseLegalUserPhone", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseLegalUserPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册类型",
      "required": true,
      "prop": "registrationType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.registrationType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "registrationType", $$v)
      },
      expression: "enterpriseInfoFormModel.registrationType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("组织机构代码证号")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("多证合一")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.enterpriseInfoFormModel.registrationType) === 0 ? '组织机构代码证号' : '社会信用代码号',
      "required": true,
      "prop": "enterpriseOrganizingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.enterpriseInfoFormModel.registrationType) === 0 ? '请输入组织机构代码证号' : '请输入社会信用代码号',
      "disabled": _vm.isEditable
    },
    model: {
      value: (_vm.enterpriseInfoFormModel.enterpriseOrganizingNumber),
      callback: function($$v) {
        _vm.$set(_vm.enterpriseInfoFormModel, "enterpriseOrganizingNumber", $$v)
      },
      expression: "enterpriseInfoFormModel.enterpriseOrganizingNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips_info el-icon-information"
  }, [_vm._v("如有信息出错，请联系管理员修改")]), _vm._v(" "), (_vm.approvalInfo !== '') ? _c('div', {
    staticClass: "tips_info el-icon-information"
  }, [_vm._v(_vm._s(_vm.approvalInfo))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.stateCode == 0) ? _c('el-button', {
    staticClass: "personal-center-form__submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交\n          ")]) : _vm._e(), _vm._v(" "), (_vm.stateCode == 2) ? _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.stateCode === 2
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("已提交\n          ")]) : _vm._e(), _vm._v(" "), (_vm.stateCode == 3) ? _c('el-button', {
    staticClass: "personal-center-form__alreadyAuth",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving,
      "disabled": _vm.stateCode === 3
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("已认证\n          ")]) : _vm._e()], 1)], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a567c31a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/RealNameAuth.vue
// module id = 2019
// module chunks = 5